(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5794],{

/***/ 77450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCREEN */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SCREEN = {
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
  MOBILE: "MOBILE"
};

var useResizeScreenModified = function useResizeScreenModified(handler) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var _window3;

      var handleScreen = function handleScreen() {
        var _window;

        if ((_window = window) !== null && _window !== void 0 && _window.innerWidth) {
          var _window2;

          if (((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerWidth) <= 1023) {
            try {
              handler(SCREEN.TABLET);
            } catch (error) {
              console.error();
            }
          } else {
            try {
              handler(SCREEN.DESKTOP);
            } catch (error) {
              console.error();
            }
          }
        }
      };

      handleScreen();
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.addEventListener("resize", handleScreen);
      return function () {
        var _window4;

        /* Clean up function. Remove event before component unmount. */
        (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.removeEventListener("resize", handleScreen);
      };
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useResizeScreenModified);

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 91630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrustpilotFeedBack; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/gr/GrFormNext.js

function GrFormNext(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "9 6 15 12 9 18"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/si/SiTrustpilot.js
var SiTrustpilot = __webpack_require__(9633);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/Index.module.scss
var Index_module = __webpack_require__(29850);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/TrustpilotFeedBack/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var dataStar = new Array(5).fill(1);
var swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".swiper-trustpilot-dots",
    clickable: true,
    bulletClass: "bbc-pagination-bullet",
    bulletActiveClass: "bbc-pagination-bullet-active"
  },
  navigation: {
    nextEl: ".swiper-trustpilot-next",
    prevEl: ".swiper-trustpilot-prev"
  },
  slidesPerView: 1,
  spaceBetween: 40
};

var Component = function Component(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(null),
      thumbsSwiper = _useState[0],
      setThumbsSwiper = _useState[1];

  function isImage(url) {
    // eslint-disable-next-line prefer-named-capture-group
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-6 justify-between lg:mt-10 lg:flex",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 lg:col-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
        spaceBetween: 10,
        thumbs: {
          swiper: thumbsSwiper
        },
        modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl]
      }, swiper), {}, {
        className: "swiperFeelback bg-bbc-main ",
        children: data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: "p-3 lg:p-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: " w-full rounded-3xl bg-white py-6 px-8 shadow-[0px_0px_12px_rgba(119,119,119,0.25)] lg:rounded-none  lg:bg-transparent lg:p-0 lg:shadow-none",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center lg:justify-start",
                children: [isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: item.avatar,
                  className: "mr-6 rounded-full",
                  alt: item.name,
                  width: 80,
                  height: 80
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((Index_module_default()).avatar, " mr-6 flex items-center justify-center rounded-full font-bold"),
                  style: {
                    backgroundColor: item.bgAvatar
                  },
                  children: item.avatar
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "mb-2  text-bbc-neutral-700",
                    children: item.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex",
                    children: dataStar.map(function (item, index) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "mr-1 flex h-6 w-6 items-center justify-center bg-[#00b67a] shadow-md",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                          className: "text-xl text-bbc-white"
                        })
                      }, index);
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "align-items-end mt-3  flex",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mr-0.5",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                        className: "text-2xl text-[#00b67a]"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-xl font-medium text-bbc-black",
                      children: "Trustpilot"
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "my-4 text-center font-semibold text-[#0042A3] opacity-[0.8] lg:text-left",
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " text-center text-bbc-gray lg:text-left",
                children: item.content
              })]
            })
          }, index);
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative  text-center lg:col-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " hidden lg:flex lg:justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
          onSwiper: setThumbsSwiper,
          spaceBetween: 5,
          slidesPerView: 3,
          freeMode: true,
          allowTouchMove: false,
          modules: [swiper_esm/* FreeMode */.Rv, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl],
          className: "swiperAvatar col-5 mr-2.5 ml-0",
          children: data.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              className: "text-center",
              children: isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: item.avatar,
                className: "cursor-pointer rounded-full",
                alt: "avatar",
                width: 60,
                height: 60
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mx-auto flex  items-center justify-center rounded-full text-2xl font-bold",
                style: {
                  width: "60px",
                  height: "60px",
                  backgroundColor: item.bgAvatar
                },
                children: item.avatar
              })
            }, index);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " mt-6 hidden h-16 lg:block",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-next absolute flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnNext, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: " text-3xl"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-prev absolute  flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnPrev, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: "rotate-180 text-3xl"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "swiper-trustpilot-dots  pt-6 "
      })]
    })]
  });
};

/* harmony default export */ var TrustpilotFeedBack = (Component);

/***/ }),

/***/ 73579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _defineProperty = __webpack_require__(61682);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _loadable = _interopRequireDefault(__webpack_require__(23668));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), options);
  var suspenseOptions = loadableOptions;

  if (true) {
    // Error if react root is not enabled and `suspense` option is set to true
    if ( true && suspenseOptions.suspense) {
      // TODO: add error doc when this feature is stable
      throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
  }

  if (suspenseOptions.suspense) {
    return loadableFn(suspenseOptions);
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})


  if (typeof loadableOptions.ssr === 'boolean') {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(2553);

var _createClass = __webpack_require__(62012);

var _defineProperty = __webpack_require__(61682);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _useSubscription = __webpack_require__(67161);

var _loadableContext = __webpack_require__(3982);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }

  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true && typeof opts.webpack === 'function' && "function" === 'function' && !opts.suspense) {
    var moduleIds = opts.webpack();
    READY_INITIALIZERS.push(function (ids) {
      var _iterator = _createForOfIteratorHelper(moduleIds),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var moduleId = _step.value;

          if (ids.indexOf(moduleId) !== -1) {
            return init();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }

  function LoadableImpl(props, ref) {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    var state = (0, _useSubscription).useSubscription(subscription);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    return _react["default"].createElement(opts.lazy, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return !opts.suspense && init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _objectSpread(_objectSpread({}, this._state), {}, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 90342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/data/trustpilot/data.json
var trustpilot_data = __webpack_require__(54356);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FaqsGroup/index.js + 1 modules
var FaqsGroup = __webpack_require__(69156);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/index.js + 1 modules
var TrustpilotFeedBack = __webpack_require__(91630);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/hk/corporate-secretary/index.js

















var NewsSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 5593).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/hk/corporate-secretary/index.js -> " + "components/organisms/NewsSlider"]
  }
});
/** ========== */

var CorporateSecretary = function CorporateSecretary(_ref) {
  var dataJson = _ref.dataJson,
      data = _ref.data;

  var _useState = (0,react.useState)(),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-min-h-569",
      wave: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 absolute bottom-0 hidden lg:block ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/wave/curve_top-wave.svg",
          className: "h-full w-full",
          width: 516,
          height: 420,
          wrapper: {
            className: "w-full h-full"
          },
          alt: "banner-img"
        })
      }),
      breadcrumbs: dataJson === null || dataJson === void 0 ? void 0 : dataJson.breadcrumbs,
      title: "Corporate Secretary<br/>Made Simple",
      leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-6 text-center lg:col-11 lg:mb-14 lg:text-left ",
        children: "Stay covered year-round with our corporate secretarial service for Hong Kong business."
      }),
      titleProps: {
        className: "banner-default-title mb-6",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-6",
      rightClassName: "lg:col-6",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/hk/corporate-secretary/banner-hk-secretary.png",
        className: "h-full w-full",
        wrapper: {
          className: "bbc-banner-image-bottom-0"
        },
        width: 666,
        height: 542,
        alt: "Hong Kong company secretary service"
      }),
      bgColor: "bg-bbc-country"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-bbc-brand-100 pt-10 lg:pt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: " mb-10 lg:mb-20",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6",
            children: "Break free from corporate governance hassle"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6",
            children: "According to Section 474, Cap. 622 Companies Ordinance, every business entities in Hong Kong have to maintain a corporate secretary at all times for administrative tasks. Appointing a corporate secretary is compulsory for any entrepreneur looking to set up a company in Hong Kong."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "So, what are the key duties of a corporate secretary in Hong Kong?"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "mb-6 list-disc pl-8",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Work with regulatory bodies and agencies such as Hong Kong Registrar of Companies, Stock Exchange of Hong Kong, etc."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Ensure the company and its operation are fully compliant with all statutory laws"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Take care of tax reports, keeping of statutory books, meeting arrangements and related corporate changes to relevant authorities"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "With a skillful and professional team, we\u2018ll sort out your secretarial work and free you from compliance risks that could set you back."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "pb-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6",
            children: "Why choosing our corporate secretarial service"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "We handle your filings, formalities, and deadlines. So you can be sure your Hong Kong business is in good standing at all times!"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6 lg:mt-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row items-center justify-between",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "mb-6 lg:col-6 lg:mb-0",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  className: "bbc-title-30",
                  children: "Meet deadlines"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "We keep you updated with important deadlines, making sure the tax obligations of your Hong Kong business are matched on time and in an efficient manner at the end of every fiscal year."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center lg:col-6 lg:text-right",
                children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/hk/corporate-secretary/services1-hk-secretary.png",
                  className: "h-full lg:w-full",
                  width: 547,
                  height: 435,
                  alt: "help you meet deadlines"
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row flex-col-reverse items-center justify-between lg:flex-row",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center lg:col-6 lg:text-left",
                children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/hk/corporate-secretary/services2-hk-secretary.png",
                  width: 452,
                  height: 367,
                  alt: "keep you updated"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "mb-6 lg:col-6 lg:mb-0",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  className: "bbc-title-30",
                  children: "Update information"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-6",
                  children: "We handle your mandatory filings and protocol."
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "We also make sure your company info is up-to-date, record any changes (i.e, you change the shareholder structure, company names, or address) and arrange amendment filings with relevant authorities if necessary. So you don\u2018t get hit with fines and penalties that could hurt your bottom line."
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row items-center justify-between ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "lg:col-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  className: "bbc-title-30",
                  children: "Stay compliant"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "Get support from our team of experts to fulfil your governance requirements and stay in good standing all the time."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center lg:col-6 lg:text-right",
                children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/hk/corporate-secretary/services3-hk-secretary.png",
                  width: 513,
                  height: 397,
                  alt: "help you stay compliant"
                })]
              })]
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 mb-10 hidden lg:mb-20 lg:block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/wave/curve_bot-wave.svg",
        className: "h-full w-full",
        width: 516,
        wrapper: {
          className: "w-full h-full"
        },
        height: 420,
        alt: "banner-img"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10",
          children: "Pricing"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
          data: dataJson.dataPricing.data.map(function (item) {
            return item.tab;
          }),
          activeTab: dataJson.dataPricing.activeTab,
          tabListClass: {
            display: "flex lg:justify-center",
            length: "w-full",
            padding: "px-1 py-3",
            border: "border-0",
            othersClass: "whitespace-nowrap overflow-x-auto mb-20 lg:mb-6"
          },
          tabClass: {
            padding: "py-2 px-4 ",
            tabColor: "text-bbc-neutral-600 border-bbc-neutral-600 hover:text-bbc-brand-500 hover:border-bbc-brand-500",
            othersClass: "mr-2 last:mr-0 font-medium"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
            children: dataJson.dataPricing.data.map(function (item, index) {
              var _item$table, _item$table$thead, _item$table2, _item$table2$tbody, _item$table3, _item$table3$tbody;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                className: "focus:outline-none focus:outline-0 focus:ring-0",
                as: "div",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "shadow-bbc-table mt-10 hidden overflow-x-auto rounded-3xl lg:block",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
                    className: " text-left text-sm text-bbc-gray ",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
                      className: "col-12 bg-bbc-brand-700  text-2xl  text-bbc-white ",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
                        children: (_item$table = item.table) === null || _item$table === void 0 ? void 0 : (_item$table$thead = _item$table.thead) === null || _item$table$thead === void 0 ? void 0 : _item$table$thead.map(function (thead, index) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                            className: "".concat(thead.width, " py-8 text-center font-semibold"),
                            children: thead.name
                          }, index);
                        })
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
                      children: (_item$table2 = item.table) === null || _item$table2 === void 0 ? void 0 : (_item$table2$tbody = _item$table2.tbody) === null || _item$table2$tbody === void 0 ? void 0 : _item$table2$tbody.map(function (thead, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                          className: " bg-bbc-white even:bg-bbc-brand-100",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                            className: "w-1/6 px-4 py-6 align-top font-medium text-bbc-brand-700",
                            children: thead.title
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                            className: "relative w-4/6 py-6 align-top before:absolute before:left-0 before:top-6 before:h-[calc(100%_-_48px)] before:w-[1px] before:bg-bbc-neutral-700 before:content-[''] after:absolute after:right-0 after:top-6 after:h-[calc(100%_-_48px)] after:w-[1px] after:bg-bbc-neutral-700 after:content-['']",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                              className: "  px-6  ",
                              children: thead.description
                            })
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                            className: "w-1/6 px-4 py-6 text-center align-top",
                            children: thead.price ? /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                              className: "list-disc font-semibold text-bbc-brand-700 ",
                              dangerouslySetInnerHTML: {
                                __html: thead.price
                              }
                            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                              href: "/contact-us",
                              className: "font-semibold text-bbc-brand-700",
                              children: "Contact us"
                            })
                          })]
                        }, index);
                      })
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mt-6 block lg:hidden",
                  children: (_item$table3 = item.table) === null || _item$table3 === void 0 ? void 0 : (_item$table3$tbody = _item$table3.tbody) === null || _item$table3$tbody === void 0 ? void 0 : _item$table3$tbody.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mb-4  rounded-2xl bg-bbc-white shadow-[0_16px_40px_0_rgba(181,181,181,0.25)]",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                        className: "border-b border-bbc-neutral-500 py-4 text-center font-medium text-bbc-brand-600",
                        children: item.title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "border-b border-bbc-neutral-500 py-6 px-7 text-center",
                        children: item.description
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "py-4 text-center",
                        children: item.price ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "font-semibold text-bbc-brand-700 ",
                          dangerouslySetInnerHTML: {
                            __html: item.price
                          }
                        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                          href: "/contact-us",
                          className: "font-semibold text-bbc-brand-700 ",
                          children: "Contact us"
                        })
                      })]
                    }, index);
                  })
                })]
              }, index);
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10",
          children: "Proactive, professional, and passionate"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: " m-auto text-center lg:col-8 ",
          children: "Whatever business you\u2018re doing, be confident you\u2018re in the best hand. When it comes to corporate secretarial service, you won\u2018t find a more committed team."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mt-10 justify-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6 flex items-center lg:col-5 lg:mr-6",
            children: screen === "DESKTOP" ? /*#__PURE__*/(0,jsx_runtime.jsx)(FaqsGroup/* default */.Z, {
              data: dataJson.dataProactive
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: dataJson.dataProactive.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: "mx-4 mb-10 text-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mb-4",
                    dangerouslySetInnerHTML: {
                      __html: item.name
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                      __html: item.content
                    }
                  })]
                }, index);
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "order-first text-center lg:col-6 lg:order-last lg:ml-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/hk/corporate-secretary/services4-hk-secretary.png",
              width: 513,
              height: 403,
              alt: "why choose our corporate secretary service"
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "m-auto lg:col-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10",
            children: "What customers say about BBCIncorp"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrustpilotFeedBack/* default */.Z, {
            data: trustpilot_data/* feedback */.I
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: dataJson.dataFaqs,
            description: " "
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var corporate_secretary = (CorporateSecretary);
;// CONCATENATED MODULE: ./pages/hk/company-secretary/data.json
var company_secretary_data_namespaceObject = JSON.parse('{"breadcrumbs":[{"uri":"/","title":"Home"},{"uri":"/corporate-secretary","title":"Company Secretary"}],"dataPricing":{"activeTab":0,"data":[{"tab":"Change Company Particulars","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Company name","description":"We support in availability check and legal compliance of your company name, file name change to CR upon demand.","price":"US$320"},{"title":"Registered address","description":"Changing the registered address requires you to notify the Companies Registry about the change and update Business Registration Certificate.","price":"US$220"},{"title":"Articles of Associations","description":"Amending the Articles of Association, i.e, holding a general meeting or issuing new classes of shares, requires you to notify the Companies Registry by filing the prescribed form with a resolution.","price":"US$220"},{"title":"Business activities","description":"By delivering a prescribed form including the description and nature of your business to the relevant authority, you can legally change business activities.","price":"US$220"}]}},{"tab":"Change company\'s officers","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Change officer\'s particulars ","description":"The Companies Registry required you to report any change of officer\'s particular such as name, identification number, residential address, etc.","price":"<li class=\'lg:text-left text-center lg:ml-4 ml-0\'>US$295 for 1st person</li><li class=\'lg:text-left text-center lg:ml-4 ml-0\'>US$100 per next person</li>"},{"title":"Appoint new officers","description":"Include the appointment of 1 employee, US$100 for the additional appointment","price":"<li class=\'lg:text-left text-center lg:ml-4 ml-0\'>US$220 for 1st person</li><li class=\'lg:text-left text-center lg:ml-4 ml-0\'>US$100 per next person</li>"},{"title":"Remove/Resign officers","description":"Include the appointment of 1 employee, US$100 for the additional appointment","price":"<li class=\'lg:text-left text-center lg:ml-4 ml-0\'>US$220 for 1st person</li><li class=\'lg:text-left text-center lg:ml-4 ml-0\'>US$100 per next person</li>"}]}},{"tab":"Share related changes","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Increase/Decrease of capital","description":"Upon demand on raising paid-in capital, you must increase the registered capital that is stated in the Articles of Association for issuing share certificates to shareholders","price":""},{"title":"Issue and allot shares","description":"You can raise the capital by issuing share certificates to shareholders.","price":""},{"title":"Transfer shares","description":"Withdrawing from a company or realizing profit is done by share transfer. We help you prepare and file related documents.","price":""},{"title":"Pay dividend","description":"The arrangement and legitimation of all internal procedures relating to getting approval from the board of directors for dividend distribution are included in our support.","price":""}]}},{"tab":"Annual compliance","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Annual return filing & AGM preparation","description":"2 key compliant duties after company registration are holding Annual General Meetings (AGMs) and filing Annual Return (AR) with relevant authorities.","price":"Including in annual renewal fee"},{"title":"Tax return filing","description":"All companies. with or without producing profits, are obligated to file tax returns to relevant authority via a prescribed form and income declaration attached with financial statements.  ","price":""},{"title":"Employer return filing","description":"Salary tax assessment requires you to file the employer\'s return to relevant authority annually or occasionally in the event of a new hire/ cessation.","price":"US$100"}]}}]},"dataProactive":[{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>Dedicated support</span>","content":"Rely on our distinguished team of consultants that attends to the specific needs of your business."},{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>Time-saving</span>","content":"Our team handles all your ongoing compliance and daunting paperwork. So you have more time to focus on what really matters!"},{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>Transparent pricing</span>","content":"Only pay for what you need with our customized pricing that perfectly fits your styles and budgets, no hidden charges guaranteed."}],"dataFaqs":[{"name":"What is a corporate secretary?","content":"<p>A corporate secretary is an officer who handles the company\'s administrative work.</p><p>He or she makes sure the company\'s operation is under Hong Kong statutory requirements, laws, and regulations.</p><p>The corporate secretary also manages the compliance status of the company. And acts as a mediator between the company\'s shareholders and directors.</p><p>The role of corporate secretaries is of vital significance. Because it affects the direction, administration, and corporate governance of a Hong Kong company.</p>"},{"name":"Who can be qualified as corporate secretary?","content":"<p>There are two types of corporate secretaries: individual and entities.</p><p>Any individual can become a corporate secretary as long as he or she resides in Hong Kong.</p><p>A foreigner residing in Hong Kong can also be a corporate secretary.</p><p>An entity needs to have a local registered office to be qualified as a corporate secretary.</p>"},{"name":"Why do Hong Kong companies need a corporate secretary?","content":"<p>As you incorporate a company in Hong Kong, the corporate secretary is one of the most important aspects.</p><p>Here are some of the primary reasons you should have a corporate secretary.</p><ul><li>&nbsp;Legal requirement to register your business</li></ul><p>Having a corporate secretary is a primary condition for any company registered in Hong Kong, according to Section 474, Cap. 622 Companies Ordinance.</p><p>You may face prosecution for trying to operate without a corporate secretary.</p><ul><li>The gatekeeper for your firm</li></ul><p>When the Hong Kong administration wants to contact your company, they\'ll reach the corporate secretary first.</p><p>The secretary will provide any clarifications or information that the government agencies require.</p><ul><li>Compliance with local laws, policies, and regulations</li></ul><p>There are specific regulations and policies for business operations in Hong Kong. A corporate secretary will help you understand and follow these obligations. He/she also ensures your business does not get into conflict with the law.</p><p></p>"}],"dataFormContact":{"title":"Ready to switch to BBCIncorp","description":"If you would like to switch to our services, we are more than happy to assist. Just fill out the form below to receive free consulting for a smooth transition."}}');
;// CONCATENATED MODULE: ./pages/hk/company-secretary/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "hk",
      page: data === null || data === void 0 ? void 0 : data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(corporate_secretary, {
        data: data,
        dataJson: company_secretary_data_namespaceObject
      })
    })
  });
}

/***/ }),

/***/ 87914:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk/company-secretary",
      function () {
        return __webpack_require__(90342);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Index_avatar__N4Fw5","btnNext":"Index_btnNext__swLTJ","btnPrev":"Index_btnPrev__KZ1Lh"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 54356:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"I":[{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#e6f5ee","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight to the point response with so solid grasp on the needs of the client.","stars":5},{"name":"Siddhant Choyal","avatar":"SC","bgAvatar":"#9df5cc","title":"My #1 recommendation for company registrations","content":"Daisy will guide you through everything and reply almost instantly 100% of the times. If you\'re looking got a HK LTD company, BBCIncorp would be my #1 recommendation. They do above and beyond, it was an absolute breeze working with them.","stars":5},{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#dfeef5","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight-to-the-point response with so solid grasp on the needs of the client.","stars":5},{"name":"Suraj","avatar":"SU","bgAvatar":"#bfd7e3","title":"Best Service !","content":"I had the pleasure of dealing with Daisy to incorporate my company, the staff at BBCincorp are professional, knowledgable and cost-effective! best service, best price and extremely competent. Would recommend it again !","stars":5},{"name":"Hasitha Dissanayake","avatar":"HD","bgAvatar":"#cdcfc8","title":"Thanks to Laura and the team for their…","content":"Thanks to Laura and the team for their professionalism and responsiveness to assist us in our company formation and bank account opening, can recommend them to anyone.","stars":5},{"name":"Michael Stoeckle","avatar":"MS","bgAvatar":"#cccfc8","title":"Great job is done by BBCIncorp","content":"The team from BBCIncorp was very fast in responding; I had an active and fruitful dialogue while the company was set up: The new venture was fully operational in less than a week which is great.","stars":5},{"name":"Jeremy","avatar":"JE","bgAvatar":"#f4fcc5","title":"Very good company","content":"Very good company. You can trust them. Frankly, this is the first time I have had to deal with a competent accountant. It changes greatly from France ^^. I had lost hope that a competent accountant existed in this world. BBCincorp gave me hope","stars":5},{"name":"Frank Duffy","avatar":"FD","bgAvatar":"#cef4f5","title":"I found BBCIncorp very easy to deal with…","content":"I found BBCIncorp very easy to deal with, they explained everything in detail from the beginning and answered any queries I had very quickly. They were efficient, pleasant to work with & I would have no problem recommending them to anyone.","stars":5},{"name":"Andrii Ch","avatar":"AC","bgAvatar":"#cef6f4","title":"Highly professional and responsive experts","content":"BBC Incorp is one of a kind international legal consultant and advisor of the highest caliber. I especially recommend working with Mrs. Linda Chen, who is a first-class legal specialist.","stars":5}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,8352,4090,9738,7447,9156,2888,179], function() { return __webpack_exec__(87914); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);